import { CustomFilterPillProps } from "../../SharedComponents/Interfaces/CustomFilterPill.interfaces";
import { createFilterPill, mapFeatureRequestFilterPillMenuItemsPredicate } from "./FeatureRequestSearch.common";

export const FEATURE_REQUEST_FILTER_PILL = {
  INITIAL_STATE: { menuItems: [], selectedMenuItems: [] },
  INITIAL_FILTER_VALUES: ["Yes", "No"].map(mapFeatureRequestFilterPillMenuItemsPredicate),
  INITIAL_DATA: [
    createFilterPill("source", "Source"),
    createFilterPill("productName", "Product Name"),
    createFilterPill("customerFacingStatus", "Customer Facing Status"),
    createFilterPill("priority", "Priority")
  ] as CustomFilterPillProps[]
};

export const FEATURE_REQUEST_COPY_TITLE = "Copy Feature Request ID/Unified Feature Request ID";

export const FEATURE_REQUEST_DATA_GRID_CONFIG = {
  rows: {
    count: 0,
    values: [],
    size: 0,
    skip: 0
  },
  pagination: {
    pageSize: 25,
    page: 0
  }
};
